import React from "react";
import { Field } from "redux-form";
import {
    Card,
    CardHeader,
    CardBody,
    Button,
    Row,
    Col,
    ButtonGroup,
} from "reactstrap";
import ApiConfig from "../../../constants/ApiConfig";
import { FieldTxt } from "../../../components/Form/wh-field";
import * as mediaService from "../../../services/media";
import * as sessionService from "../../../services/session";

class DocumentCollection extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            fields: this.props.fields,
            closed: [],
        };

        this.onImgChange = this.onImgChange.bind(this);

    }

    create(fields){
        fields.push({});
    };

    remove(fields, index){
        fields.remove(index);
    };


    openMediaBox(id) {

        let token = sessionService.getToken()

        let params = {
            access_token    : `${token.access_token}`,
            type            : 'api',
            url             : ApiConfig.finderParams.url,
            endPointMedia   : ApiConfig.finderParams.endPointMedia,
            assetUrl        : ApiConfig.finderParams.assetUrl
        };

        let str = '';
        for (let key in params) {
            if (str != "") {
                str += "&";
            }
            str += key + "=" + encodeURIComponent(params[key]);
        }


        const url = `/wh-finder/index.html?${str}#/?id=${id}`;

        window.open(url,"wh media center","location=no, menubar=no, status=no, scrollbars=no, menubar=no, width=800, height=600");

    }



    onImgChange(data, fields, index) {

        let val = data.target.value;

        mediaService.search({filtered : [{id : 'url', value : val}]}).then((data) => {

            data = data['hydra:member'][0];

            let content = fields.get(index);

            content.media = data;
            fields.remove(index);
            fields.insert(index, content);

        });


    }

    render() {
        const { fields } = this.props;

        return (
            <div>
                <Row>
                    {fields.map((el, index) => (
                        <Col key={index} xs={12}>
                            <Card>
                                <CardHeader>
                                    <i className="fa fa-image" /> Document{" "}
                                    {index}
                                    <div className="card-actions">

                                        <a
                                            onClick={() =>
                                                this.remove(fields, index)
                                            }
                                        >
                                            <i className={"fa fa-trash"} />
                                        </a>
                                    </div>
                                </CardHeader>

                                <CardBody>
                                    <Field
                                        label={false}
                                        name={`${el}.title`}
                                        type="text"
                                        component={FieldTxt}
                                        placeholder={'Saisir un titre'}
                                    />
                                    {fields.get(index).url && (
                                        <img
                                            src={`${
                                                ApiConfig.finderParams.assetUrl
                                            }${fields.get(index).url}`}
                                            style={{ maxWidth: "100%" }}
                                        />
                                    )}

                                    <Col sm={5} xs={12}>

                                    <input type="text" id={`documentField${index}`} onChange={(event) => this.onImgChange(event, fields, index)} style={{position : 'absolute', left : '-90000px'}} />

                                    {
                                    fields.get(index).media &&
                                    fields.get(index).media.url &&
                                    fields.get(index).media.type == 'document' &&
                                    <i className={'fa fa-file'} />
                                    }

                                        <Button color={'success'} block onClick={() => this.openMediaBox(`documentField${index}`)}>Media</Button>
                                    </Col>

                                </CardBody>
                            </Card>
                        </Col>
                    ))}
                </Row>

                <Card>
                    <ButtonGroup>
                        <Button
                            size="lg"
                            onClick={() => this.create(fields)}
                            style={{ flex: 1 }}
                        >
                            Ajouter un document
                        </Button>
                    </ButtonGroup>
                </Card>
            </div>
        );
    }
}

export default DocumentCollection;



// WEBPACK FOOTER //
// ./src/views/Cms/Posts/DocumentCollection.js